import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { setStorage } from '@/lib/utility'
import {
  getImeiMsg // 获取卡池信息
} from '@/servives/eqApi'

@Module({ namespaced: true, name: 'Common' })
export default class Common extends VuexModule {
  public Token = ''
  public ImeiMsg: any = {
  }

  @Mutation
  saveToken (data: any) {
    this.Token = data.payload
    setStorage('token', data.payload)
  }

  @Mutation
  saveImeiMsg (data: any) {
    this.ImeiMsg = data.payload
  }

  @Action
  async getImeiMsg ({ payload }: { payload: any }) {
    const response = await getImeiMsg({ ...payload.params })
    if (response.status === 1) {
      this.context.commit({
        type: 'saveImeiMsg',
        payload: response
      })
    }
    return response
  }
}
